import { PropertyVendorsContainer } from 'components/modules/Properties/Details/Vendors';

export const PropertyVendors = () => <PropertyVendorsContainer />;
